module.exports = __webpack_public_path__ + "static/bedroom_top_right_night-66a2529c06dbebd1e413da3536b5841f.jpg";